import React, { useEffect, useState } from 'react'
import {
  Grid,
  FormControl,
  TextField,
  Button,
  Select,
  MenuItem,
  CircularProgress,
} from '@material-ui/core'
import './crearFormulario.scss'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useForm } from '../../../../context/formContext'
import { useAuthentication } from '../../../../context/authenticationContext'
import NumberFormat from 'react-number-format'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import ReactTooltip from 'react-tooltip'
import { getCurrencyExchange } from '../../../../services/Forms/get'

const GeneralData = (props) => {
  const { nextStep } = props
  const {
    setStep,
    step,
    setPreEligibilityForm,
    preEligibilityForm,
    miPymesType,
    currencies,
    editForm,
    idEditForm,
    setCheckPYME,
  } = useForm()

  const { userCountry, userFullName } = useAuthentication()
  const [showRequiredAmount, setShowRequiredAmount] = useState(false)
  const [showExchange, setShowExchange] = useState(false)
  const [loadingExchange, setLoadingExchange] = useState(false)
  const [amountExchange, setAmountExchange] = useState('$0.00')
  const [amountTest, setAmountTest] = useState('')
  const [exchangeError, setExchangeError] = useState(false)

  const GeneralDataSchema = Yup.object().shape({
    userFullName: Yup.string().required('Este campo es obligatorio'),
    companyId: Yup.string().required('Este campo es obligatorio'),
    companyName: Yup.string().required('Este campo es obligatorio'),
    companyTypeId: Yup.number().required('Este campo es obligatorio'),
    legalRepresentativeFullName: Yup.string().required(
      'Este campo es obligatorio',
    ),
    legalRepresentativeIdentification: Yup.string().required(
      'Este campo es obligatorio',
    ),
    subprojectName: Yup.string().required('Este campo es obligatorio'),
    quantityEmployees: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio')
      .test(
        'superior',
        'El número de empleados debe ser mayor que 0',
        function (f) {
          const ref = 0
          return f > this.resolve(ref)
        },
      ),
    idCurrency: Yup.number().required('Este campo es obligatorio'),
    requiredAmountSourceCurrency: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio')
      .when('idCurrency', {
        is: (idCurrency) => idCurrency !== 3,
        then: Yup.number().test(
          'superior',
          'El monto requerido debe ser mayor que 0',
          function (f) {
            const ref = 0
            return f > this.resolve(ref)
          },
        ),
      }),
    requiredAmountDollarsCurrency: Yup.number()
      .typeError('Este campo es obligatorio')
      .when('idCurrency', {
        is: (idCurrency) => idCurrency === 3,
        then: Yup.number().test(
          'superior',
          'El monto requerido debe ser mayor que 0',
          function (f) {
            const ref = 0
            return f > this.resolve(ref)
          },
        ),
      }),
  })

  const formik = useFormik({
    initialValues: {
      idForm: idEditForm && idEditForm,
      userFullName: userFullName,
      companyName:
        editForm.list &&
        editForm.list.MiPyme &&
        editForm.list.MiPyme.BusinessName
          ? editForm.list.MiPyme.BusinessName
          : '',
      companyTypeId:
        editForm.list &&
        editForm.list.MiPyme &&
        editForm.list.MiPyme.IdMiPymeType &&
        editForm.list.MiPyme.IdMiPymeType
          ? editForm.list.MiPyme.IdMiPymeType
          : '',
      companyId:
        editForm.list &&
        editForm.list.MiPyme &&
        editForm.list.MiPyme.TaxRegistration
          ? editForm.list.MiPyme.TaxRegistration
          : '',
      legalRepresentativeFullName:
        editForm.list && editForm.list.LegalRepresentativeName
          ? editForm.list.LegalRepresentativeName
          : '',
      legalRepresentativeIdentification:
        editForm.list && editForm.list.LegalRepresentativeIdentification
          ? editForm.list.LegalRepresentativeIdentification
          : '',
      subprojectName:
        editForm.list && editForm.list.Project.SubprojectName
          ? editForm.list.Project.SubprojectName
          : '',
      quantityEmployees:
        editForm.list &&
        editForm.list.MiPyme &&
        editForm.list.QuantityPermanentEmployees
          ? editForm.list.QuantityPermanentEmployees
          : '',
      idCurrency:
        editForm.list &&
        editForm.list.Currency &&
        editForm.list.Currency.IdCurrency
          ? editForm.list.Currency.IdCurrency
          : 0,
      requiredAmountSourceCurrency:
        editForm.list && editForm.list.RequiredAmountSourceCurrency
          ? editForm.list.RequiredAmountSourceCurrency
          : '0',
      requiredAmountDollarsCurrency:
        editForm.list && editForm.list.RequiredAmountDollarsCurrency
          ? editForm.list.RequiredAmountDollarsCurrency.toString()
          : '0',
      isInProtectedArea:
        editForm.list && editForm.list.IsInProtectedArea !== null
          ? editForm.list.IsInProtectedArea
          : '',
      protectedAreaLocation:
        editForm.list && editForm.list.ProtectedAreaLocation
          ? editForm.list.ProtectedAreaLocation
          : '',
      affectsCulturalHeritage:
        editForm.list && editForm.list.AffectsCulturalHeritage !== null
          ? editForm.list.AffectsCulturalHeritage
          : '',
      detailAffectsCulturalHeritage:
        editForm.list && editForm.list.DetailAffectsCulturalHeritage
          ? editForm.list.DetailAffectsCulturalHeritage
          : '',

      answerActivityQuestion:
        editForm.list && editForm.list.AnnexAnswer
          ? editForm.list.AnnexAnswer
          : [],

      idClimateThreat:
        editForm.list &&
        editForm.list.ClimateThreat &&
        editForm.list.ClimateThreat.ClimateThreat
          ? editForm.list.ClimateThreat.ClimateThreat
          : '',
      idSector:
        editForm.list && editForm.list.Sector && editForm.list.Sector
          ? editForm.list.Sector
          : '',
      idSectorActivity:
        editForm.list &&
        editForm.list.Activity &&
        editForm.list.Activity.IdActivity
          ? editForm.list.Activity.IdActivity
          : null,
      detailSector:
        editForm.list && editForm.list.DetailSector
          ? editForm.list.DetailSector
          : '',
      detailActivity:
        editForm.list && editForm.list.DetailActivity
          ? editForm.list.DetailActivity
          : '',

      detailClimateThreat:
        editForm.list && editForm.list.DetailClimateThreat
          ? editForm.list.DetailClimateThreat
          : '',

      idBusinessLine:
        editForm.list &&
        editForm.list.BusinessLine &&
        editForm.list.BusinessLine.IdBusinessLine
          ? editForm.list.BusinessLine.IdBusinessLine
          : '',
      detailAdaptationAction:
        editForm.list && editForm.list.DetailAdaptationActions
          ? editForm.list.DetailAdaptationActions
          : '',
      idAdaptationAction:
        editForm.list &&
        editForm.list.adaptationActions &&
        editForm.list.adaptationActions.idAdaptationAction
          ? editForm.list.adaptationActions.idAdaptationAction
          : '',
      idDepartment:
        editForm.list && editForm.list.Project.IdDepartment
          ? editForm.list.Project.IdDepartment
          : '',
      idMunicipality:
        editForm.list && editForm.list.Project.IdMunicipality
          ? editForm.list.Project.IdMunicipality
          : '',
      companyPhone:
        editForm.list && editForm.list.Project.Phone
          ? editForm.list.Project.Phone
          : '',
      companyAddress:
        editForm.list && editForm.list.Project.Address
          ? editForm.list.Project.Address
          : '',
    },
    validationSchema: GeneralDataSchema,
    onSubmit: (values) => {
      next()
    },
  })

  useEffect(() => {
    setPreEligibilityForm({
      ...preEligibilityForm,
      ...editForm.list,
    })
    setPreEligibilityForm({
      ...preEligibilityForm,
      userFullName: '',
      companyName: '',
    })
  }, [])

  useEffect(() => {
    // datos obligatiros
    if (
      formik.values.companyId !== '' &&
      formik.values.legalRepresentativeFullName !== '' &&
      formik.values.legalRepresentativeIdentification !== '' &&
      formik.values.subprojectName !== '' &&
      formik.values.quantityEmployees !== null &&
      formik.values.quantityEmployees !== '' &&
      formik.values.idCurrency !== '' &&
      formik.values.requiredAmountDollarsCurrency !== '' &&
      formik.values.quantityEmployees !== 0
    ) {
      setCheckPYME(true)
    } else {
      setCheckPYME(false)
    }
  }, [
    formik.values.companyId,
    formik.values.legalRepresentativeFullName,
    formik.values.legalRepresentativeIdentification,
    formik.values.subprojectName,
    formik.values.quantityEmployees,
    formik.values.quantityEmployees,
    formik.values.idCurrency,
    formik.values.requiredAmountDollarsCurrency,
  ])

  useEffect(() => {
    if (editForm.list && editForm.list.RequiredAmountDollarsCurrency) {
      setAmountExchange(`$${editForm.list.RequiredAmountDollarsCurrency}`)
    } else {
      setAmountExchange('$0.00')
    }
  }, [editForm.list])

  useEffect(() => {
    if (
      formik.values.idCurrency !== '' &&
      formik.values.idCurrency !== undefined &&
      formik.values.idCurrency === 3 &&
      formik.values.idCurrency > 0
    ) {
      setShowRequiredAmount(true)
      setLoadingExchange(false)
      setAmountExchange('$0.00')
    } else if (
      formik.values.idCurrency !== '' &&
      formik.values.idCurrency !== undefined &&
      formik.values.idCurrency !== 3 &&
      formik.values.idCurrency > 0
    ) {
      setShowRequiredAmount(true)
      setShowExchange(true)

      if (
        formik.values.requiredAmountSourceCurrency !== '' &&
        formik.values.idCurrency !== undefined
      ) {
        getExchange()
      }
    } else {
      setShowRequiredAmount(false)
      setPreEligibilityForm({
        ...preEligibilityForm,
        requiredAmountSourceCurrency: '',
      })
    }
  }, [formik.values.idCurrency])

  const next = () => {
    setStep(step + 1)
    setPreEligibilityForm({
      ...preEligibilityForm,
      idForm: formik.values.idForm,
      userFullName: formik.values.userFullName,
      companyName: formik.values.companyName,
      companyTypeId: formik.values.companyTypeId,
      companyId: formik.values.companyId,
      legalRepresentativeFullName:
        formik.values.legalRepresentativeFullName !==
        preEligibilityForm.legalRepresentativeFullName
          ? preEligibilityForm.legalRepresentativeFullName
          : formik.values.legalRepresentativeFullName,
      legalRepresentativeIdentification: formik.values
        .legalRepresentativeIdentification
        ? preEligibilityForm.legalRepresentativeIdentification
        : formik.values.legalRepresentativeIdentification,
      subprojectName:
        formik.values.subprojectName !== preEligibilityForm.subprojectName
          ? preEligibilityForm.subprojectName
          : formik.values.subprojectName,
      quantityEmployees:
        formik.values.quantityEmployees !== preEligibilityForm.quantityEmployees
          ? preEligibilityForm.quantityEmployees
          : formik.values.quantityEmployees,
      idCurrency:
        formik.values.idCurrency !== preEligibilityForm.idCurrency
          ? preEligibilityForm.idCurrency
          : formik.values.idCurrency,
      requiredAmountSourceCurrency:
        formik.values.requiredAmountSourceCurrency !==
        preEligibilityForm.requiredAmountSourceCurrency
          ? preEligibilityForm.requiredAmountSourceCurrency
          : formik.values.requiredAmountSourceCurrency,
      requiredAmountDollarsCurrency:
        formik.values.requiredAmountDollarsCurrency.toString() !==
        preEligibilityForm.requiredAmountDollarsCurrency
          ? preEligibilityForm.requiredAmountDollarsCurrency
          : formik.values.requiredAmountDollarsCurrency.toString(),
      isInProtectedArea:
        formik.values.isInProtectedArea !== preEligibilityForm.isInProtectedArea
          ? preEligibilityForm.isInProtectedArea
          : formik.values.isInProtectedArea,
      answerActivityQuestion: formik.values.answerActivityQuestion,

      affectsCulturalHeritage:
        formik.values.affectsCulturalHeritage !==
        preEligibilityForm.affectsCulturalHeritage
          ? preEligibilityForm.affectsCulturalHeritage
          : formik.values.affectsCulturalHeritage,
      idClimateThreat:
        formik.values.idClimateThreat !== preEligibilityForm.idClimateThreat
          ? preEligibilityForm.idClimateThreat
          : formik.values.idClimateThreat,
      detailClimateThreat:
        formik.values.detailClimateThreat !==
        preEligibilityForm.detailClimateThreat
          ? preEligibilityForm.detailClimateThreat
          : formik.values.detailClimateThreat,
      detailAffectsCulturalHeritage:
        formik.values.detailAffectsCulturalHeritage !==
        preEligibilityForm.detailAffectsCulturalHeritage
          ? preEligibilityForm.detailAffectsCulturalHeritage
          : formik.values.detailAffectsCulturalHeritage,
      idSector:
        formik.values.idSector !== preEligibilityForm.idSector
          ? preEligibilityForm.idSector
          : formik.values.idSector,
      detailAdaptationAction:
        formik.values.detailAdaptationAction !==
        preEligibilityForm.detailAdaptationAction
          ? preEligibilityForm.detailAdaptationAction
          : formik.values.detailAdaptationAction,
      idAdaptationAction:
        formik.values.idAdaptationAction !==
        preEligibilityForm.idAdaptationAction
          ? preEligibilityForm.idAdaptationAction
          : formik.values.idAdaptationAction,
      idBusinessLine:
        formik.values.idBusinessLine !== preEligibilityForm.idBusinessLine
          ? preEligibilityForm.idBusinessLine
          : formik.values.idBusinessLine,
      idSectorActivity:
        formik.values.idSectorActivity !== preEligibilityForm.idSectorActivity
          ? preEligibilityForm.idSectorActivity
          : formik.values.idSectorActivity,
      detailSector:
        formik.values.detailSector !== preEligibilityForm.detailSector
          ? preEligibilityForm.detailSector
          : formik.values.detailSector,
      detailActivity:
        formik.values.detailActivity !== preEligibilityForm.detailActivity
          ? preEligibilityForm.detailActivity
          : formik.values.detailActivity,
      idDepartment:
        formik.values.idDepartment !== preEligibilityForm.idDepartment
          ? preEligibilityForm.idDepartment
          : formik.values.idDepartment,
      idMunicipality:
        formik.values.idMunicipality !== preEligibilityForm.idMunicipality
          ? preEligibilityForm.idMunicipality
          : formik.values.idMunicipality,
      companyPhone:
        formik.values.companyPhone !== preEligibilityForm.companyPhone
          ? preEligibilityForm.companyPhone
          : formik.values.companyPhone,
      companyAddress:
        formik.values.companyAddress !== preEligibilityForm.companyAddress
          ? preEligibilityForm.companyAddress
          : formik.values.companyAddress,
    })
    nextStep()
  }

  useEffect(() => {
    if (editForm.list && editForm.list.annexAnswer) {
      setPreEligibilityForm({
        ...preEligibilityForm,
        answerActivityQuestion: editForm.list.annexAnswer,
      })
    }
  }, [editForm.list])

  useEffect(() => {
    if (preEligibilityForm && preEligibilityForm.answerActivityQuestion) {
      questionsStruct(preEligibilityForm)
    }
  }, [preEligibilityForm.answerActivityQuestion])

  const questionsStruct = (question) => {
    const questions = []

    /* const compare =
      JSON.stringify(question.answerActivityQuestion) ===
      JSON.stringify(formik.values.answerActivityQuestion) */

    /* if (!compare) {
      return formik.setValues({
        ...formik.values,
        answerActivityQuestion: question.answerActivityQuestion,
      })
    }
 */
    if (
      question &&
      question.answerActivityQuestion &&
      question.answerActivityQuestion.length >= 0
    ) {
      for (let i = 0; i < question.answerActivityQuestion.length; i++) {
        const struct = {
          idActivityQuestion: parseInt(
            question.answerActivityQuestion[i].idActivityQuestion,
          ),
          value:
            question.answerActivityQuestion[i].answer ||
            question.answerActivityQuestion[i].value,
          valueType:
            question.answerActivityQuestion[i].questionTypeName ||
            question.answerActivityQuestion[i].valueType,
        }
        questions.push(struct)
      }

      return formik.setValues({
        ...formik.values,
        answerActivityQuestion: questions,
      })
    } else {
      return 0
    }
  }

  /*   const compareArrays = (questions, otherQuestions) => {
    if (questions && otherQuestions) {
      const result =
        JSON.stringify(questions) === JSON.stringify(otherQuestions)

      if (result) {
        return 0
      } else {
        formik.setFieldValue(
          'answerActivityQuestion',
          preEligibilityForm.answerActivityQuestion,
        )
      }
    }
  } */

  useEffect(() => {
    if (formik.values.idCurrency === '') {
      setAmountTest('')
      setShowRequiredAmount(false)
      setShowExchange(false)
      setAmountExchange('$0.00')
      formik.setFieldValue('requiredAmountDollarsCurrency', '')
      formik.setFieldValue('requiredAmountSourceCurrency', '')
      setPreEligibilityForm({
        ...preEligibilityForm,
        requiredAmountSourceCurrency: '0',
        requiredAmountDollarsCurrency: '0',
      })
    }

    if (formik.values.idCurrency !== '' && formik.values.idCurrency !== 3) {
      setAmountTest('')
      setLoadingExchange(false)
      formik.setFieldValue('requiredAmountDollarsCurrency', '')
      formik.setFieldValue('requiredAmountSourceCurrency', '')
      setPreEligibilityForm({
        ...preEligibilityForm,
        requiredAmountSourceCurrency: '0',
        requiredAmountDollarsCurrency: '0',
      })
    }

    if (formik.values.idCurrency !== '' && formik.values.idCurrency === 3) {
      setAmountTest('')
      formik.setFieldValue('requiredAmountDollarsCurrency', '')
      formik.setFieldValue('requiredAmountSourceCurrency', '')
      setPreEligibilityForm({
        ...preEligibilityForm,
        requiredAmountSourceCurrency: '0',
        requiredAmountDollarsCurrency: '0',
      })
    }
  }, [formik.values.idCurrency])

  useEffect(() => {
    if (editForm.list?.Currency) {
      if (
        editForm.list &&
        editForm.list.RequiredAmountDollarsCurrency &&
        editForm.list.Currency &&
        editForm.list.Currency.IdCurrency === 3
      ) {
        setLoadingExchange(false)
        setExchangeError(false)
        setAmountTest(editForm.list.RequiredAmountDollarsCurrency)
        formik.setFieldValue(
          'requiredAmountDollarsCurrency',
          editForm.list.RequiredAmountDollarsCurrency,
        )
        formik.setFieldValue('requiredAmountSourceCurrency', '0')
        setPreEligibilityForm({
          ...preEligibilityForm,
          requiredAmountSourceCurrency: '0',
          requiredAmountDollarsCurrency:
            editForm.list.RequiredAmountDollarsCurrency,
        })
      }

      if (
        editForm.list &&
        editForm.list.RequiredAmountDollarsCurrency &&
        editForm.list.Currency &&
        editForm.list.Currency.IdCurrency !== 3
      ) {
        setLoadingExchange(true)
        setExchangeError(false)
        setAmountTest(editForm.list.RequiredAmountSourceCurrency)
        formik.setFieldValue(
          'requiredAmountDollarsCurrency',
          editForm.list.RequiredAmountDollarsCurrency,
        )
        formik.setFieldValue(
          'requiredAmountSourceCurrency',
          editForm.list.RequiredAmountSourceCurrency,
        )
        setPreEligibilityForm({
          ...preEligibilityForm,
          requiredAmountSourceCurrency:
            editForm.list.RequiredAmountSourceCurrency,
          requiredAmountDollarsCurrency:
            editForm.list.RequiredAmountDollarsCurrency,
        })
      }

      if (
        editForm.list &&
        editForm.list.Currency &&
        editForm.list.Currency.IdCurrency === ''
      ) {
        setAmountTest('0')
        formik.setFieldValue('requiredAmountDollarsCurrency', '')
        formik.setFieldValue('requiredAmountSourceCurrency', '')
        setPreEligibilityForm({
          ...preEligibilityForm,
          RequiredAmountSourceCurrency: '0',
          RequiredAmountDollarsCurrency: '0',
        })
      }
    }
  }, [editForm.list])

  const getExchange = () => {
    setLoadingExchange(true)

    let currencyCode = ''

    setExchangeError(false)

    if (
      formik.values.requiredAmountSourceCurrency !== '' &&
      formik.values.idCurrency > 0 &&
      formik.values.idCurrency !== undefined &&
      currencies &&
      currencies.length > 0
    ) {
      for (let i = 0; i <= currencies.length; i++) {
        if (currencies[i].IdCurrency === formik.values.idCurrency) {
          currencyCode = currencies[i].CurrencyCode
          break
        }
      }
    }

    if (
      formik.values.idCurrency !== 3 &&
      formik.values.idCurrency !== '' &&
      formik.values.idCurrency !== undefined
    ) {
      if (formik.values.requiredAmountSourceCurrency !== '') {
        const amountCurrencyCode = currencyCode
        const params = {
          SourceCurrencyCode: amountCurrencyCode,
          TargetCurrencyCode: 'USD',
          OriginalAmount: formik.values.requiredAmountSourceCurrency,
        }
        getCurrencyExchange(params)
          .then((res) => {
            if (
              res.error !== null ||
              res?.result
                ?.retrieveGlobalStandardSpecificationCurrencyExchangeResponse
                ?.currencyExchange?.resultingAmount === 0
            ) {
              setLoadingExchange(false)
              setAmountExchange('$0.00')
              setExchangeError(true)

              if (
                res?.result
                  ?.retrieveGlobalStandardSpecificationCurrencyExchangeResponse
                  ?.currencyExchange?.resultingAmount === 0
              ) {
                setLoadingExchange(false)
                setAmountExchange('$0.00')
                setExchangeError(true)
              }
            } else {
              if (
                res?.result
                  ?.retrieveGlobalStandardSpecificationCurrencyExchangeResponse
                  ?.currencyExchange?.resultingAmount
              ) {
                setAmountExchange(
                  `$ ${res?.result?.retrieveGlobalStandardSpecificationCurrencyExchangeResponse?.currencyExchange?.resultingAmount}`,
                )

                formik.setFieldValue(
                  'requiredAmountDollarsCurrency',
                  res?.result
                    ?.retrieveGlobalStandardSpecificationCurrencyExchangeResponse
                    ?.currencyExchange?.resultingAmount,
                )

                setPreEligibilityForm({
                  ...preEligibilityForm,
                  requiredAmountDollarsCurrency:
                    res?.result
                      ?.retrieveGlobalStandardSpecificationCurrencyExchangeResponse
                      ?.currencyExchange?.resultingAmount,
                })
                setLoadingExchange(false)
                setExchangeError(false)
              } else {
                formik.setFieldValue('requiredAmountDollarsCurrency', '0')

                setPreEligibilityForm({
                  ...preEligibilityForm,
                  requiredAmountDollarsCurrency: '0',
                })
              }
            }
          })
          .catch((err) => {
            console.log(err)
            setExchangeError(true)
            setLoadingExchange(false)
            setAmountExchange('$0.00')
          })
      } else {
        setLoadingExchange(false)
        setAmountExchange('$0.00')
      }
    } else {
      setLoadingExchange(false)
      setAmountExchange('$0.00')
    }
  }

  const getPatternMiPymeId = () => {
    if (parseInt(userCountry) !== null) {
      switch (parseInt(userCountry)) {
        case 1:
          return '[\\0-9]{0,15}'
        case 2:
          return '[sa-zA-ZñÑ0-9]{0,15}'
        case 3:
          return '[0-9]{0,15}'
        case 4:
          return '[sa-zA-ZñÑ0-9]{0,15}'
        case 5:
          return '[0-9]{0,15}'
        case 6:
          return '[sa-zA-ZñÑ0-9]{0,17}'
        case 7:
          return '[0-9]{0,15}'
        default:
          return null
      }
    } else {
      return null
    }
  }

  useEffect(() => {
    if (editForm.list?.Currency) {
      if (editForm.list && editForm.list.Currency.IdCurrency) {
        formik.setFieldValue('idCurrency', editForm.list.Currency.IdCurrency)
      }
    }
  }, [editForm.list])

  return (
    <>
      <form id="transfers-form" onSubmit={formik.handleSubmit}>
        <Grid container spacing={1}>
          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">1. Nombre Completo</label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="fullName"
                  style={{ width: '100%' }}
                  error={formik.errors.userFullName}
                  variant="outlined"
                  disabled
                  onChange={(e) => {
                    formik.setFieldValue('userFullName', e.target.value)
                    if (!formik.errors.userFullName) {
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        userFullName: e.target.value,
                      })
                    }
                  }}
                  value={formik.values.userFullName}
                />
                {formik.errors.userFullName ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.userFullName}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">2. Nombre de la MIPYME</label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="companyName"
                  style={{ width: '100%' }}
                  error={formik.errors.companyName}
                  variant="outlined"
                  disabled
                  onChange={(e) => {
                    formik.setFieldValue('companyName', e.target.value)
                    if (!formik.errors.companyName) {
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        companyName: e.target.value,
                      })
                    }
                  }}
                  value={formik.values.companyName}
                />
                {formik.errors.companyName ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.companyName}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">3.Tipo de la MIPYME</label>{' '}
              {/* <span style={{ color: 'red' }}>*</span> */}
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                <Select
                  id="companyTypeId"
                  value={formik.values.companyTypeId}
                  onChange={(e) => {
                    formik.setFieldValue('companyTypeId', e.target.value)
                    setPreEligibilityForm({
                      ...preEligibilityForm,
                      companyTypeId: e.target.value,
                    })
                  }}
                  variant="outlined"
                  error={formik.errors.companyTypeId}
                  disabled
                >
                  <MenuItem value={''}>Seleccione una opción</MenuItem>
                  {miPymesType &&
                    miPymesType.map((item, key) => (
                      <MenuItem key={key} value={item.IdMiPymeType}>
                        {item.Description}
                      </MenuItem>
                    ))}
                </Select>
                {formik.errors.companyTypeId ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.companyTypeId}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                4. Registro tributario o identificación de la MIPYME{' '}
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="companyId"
                  style={{ width: '100%' }}
                  error={formik.errors.companyId}
                  variant="outlined"
                  onChange={(e) => {
                    formik.setFieldValue('companyId', e.target.value)
                    if (!formik.errors.companyId) {
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        companyId: e.target.value,
                      })
                    }
                  }}
                  value={formik.values.companyId}
                  disabled
                />
                {formik.errors.companyId ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.companyId}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                5. Nombre del representante legal{' '}
                <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="legalRepresentativeFullName"
                  style={{ width: '100%' }}
                  error={formik.errors.legalRepresentativeFullName}
                  variant="outlined"
                  value={formik.values.legalRepresentativeFullName}
                  inputProps={{
                    maxLength: 100,
                    autoComplete: 'new-text',
                    pattern: '[\\sa-zA-ZñÑäÄëËïÏöÖüÜáÁéÉíÍóÓúÚ]{0,100}',
                  }}
                  onChange={(e) => {
                    formik.setFieldValue(
                      'legalRepresentativeFullName',
                      e.target.value.trimStart(),
                    )
                    setPreEligibilityForm({
                      ...preEligibilityForm,
                      legalRepresentativeFullName: e.target.value.trimStart(),
                    })
                    // if (e.target.validity.valid) {
                    //   formik.setFieldValue(
                    //     'legalRepresentativeFullName',
                    //     e.target.value,
                    //   )
                    //   if (!formik.errors.legalRepresentativeFullName) {
                    //     setPreEligibilityForm({
                    //       ...preEligibilityForm,
                    //       legalRepresentativeFullName: e.target.value,
                    //     })
                    //   }
                    // }
                  }}
                />
                {formik.errors.legalRepresentativeFullName ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.legalRepresentativeFullName}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                6. Número de identificación del representante legal{' '}
                <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="legalRepresentativeIdentification"
                  style={{ width: '100%' }}
                  error={formik.errors.legalRepresentativeIdentification}
                  variant="outlined"
                  inputProps={{
                    autoComplete: 'off',
                    pattern: getPatternMiPymeId(),
                  }}
                  onChange={(e) => {
                    if (e.target.validity.valid) {
                      formik.setFieldValue(
                        'legalRepresentativeIdentification',
                        e.target.value,
                      )
                      if (!formik.errors.legalRepresentativeIdentification) {
                        setPreEligibilityForm({
                          ...preEligibilityForm,
                          legalRepresentativeIdentification: e.target.value,
                        })
                      }
                    }
                  }}
                  value={formik.values.legalRepresentativeIdentification}
                />
                {formik.errors.legalRepresentativeIdentification ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.legalRepresentativeIdentification}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                7. Nombre del Subproyecto{' '}
                <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="subprojectName"
                  style={{ width: '100%' }}
                  error={formik.errors.subprojectName}
                  variant="outlined"
                  inputProps={{
                    autoComplete: 'off',

                    maxLength: 100,
                  }}
                  onChange={(e) => {
                    if (e.target.validity.valid) {
                      formik.setFieldValue('subprojectName', e.target.value)
                      if (!formik.errors.subprojectName) {
                        setPreEligibilityForm({
                          ...preEligibilityForm,
                          subprojectName: e.target.value,
                        })
                      }
                    }
                  }}
                  value={formik.values.subprojectName}
                />
                {formik.errors.subprojectName ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.subprojectName}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                8. Cantidad de empleados permanentes{' '}
                <span style={{ color: 'red' }}>*</span>
                <a
                  data-tip="Ingrese la cantidad total de empleados permanentes<br/> o directos de la MIPYME; no incluir empleados eventuales."
                  data-for="infoEmployesPop"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoEmployesPop"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                {/* <TextField
                  id="quantityEmployees"
                  style={{ width: '100%' }}
                  error={formik.errors.quantityEmployees}
                  variant="outlined"
                  inputProps={{
                    autoComplete: 'off',
                    pattern: '[0-9]{0,5}',
                  }}
                  onChange={(e) => {
                    if (e.target.validity.valid) {
                      if (e.target.value !== '') {
                        formik.setFieldValue(
                          'quantityEmployees',
                          parseInt(e.target.value),
                        )
                        if (!formik.errors.quantityEmployees) {
                          setPreEligibilityForm({
                            ...preEligibilityForm,
                            quantityEmployees: parseInt(e.target.value),
                          })
                        }
                      } else {
                        formik.setFieldValue('quantityEmployees', '')
                        setPreEligibilityForm({
                          ...preEligibilityForm,
                          quantityEmployees: '',
                        })
                      }
                    }
                  }}
                  value={formik.values.quantityEmployees}
                /> */}
                <NumberFormat
                  id="quantityEmployees"
                  name="quantityEmployees"
                  customInput={TextField}
                  thousandSeparator={true}
                  value={formik.values.quantityEmployees}
                  onChange={(e) => {
                    if (e.target.value.replaceAll(',', '') !== '') {
                      formik.setFieldValue(
                        'quantityEmployees',
                        parseInt(e.target.value.replaceAll(',', '')),
                      )
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        quantityEmployees: parseInt(
                          e.target.value.replaceAll(',', ''),
                        ),
                      })
                    } else {
                      formik.setFieldValue('quantityEmployees', '')
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        quantityEmployees: '',
                      })
                    }
                  }}
                  autoComplete="off"
                  allowNegative={false}
                  error={formik.errors.quantityEmployees}
                  variant="outlined"
                  isNumericString={true}
                  inputProps={{ maxLength: 5 }}
                  fixedDecimalScale
                  decimalScale={0}
                />
                {formik.errors.quantityEmployees ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.quantityEmployees}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                9. Moneda del monto <span style={{ color: 'red' }}>*</span>
                <a
                  data-tip="Ingrese la moneda de préstamo"
                  data-for="infoCurrencyPop"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoCurrencyPop"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                <Select
                  id="currency"
                  value={formik.values.idCurrency}
                  onChange={(e) => {
                    formik.setFieldValue('idCurrency', e.target.value)
                    if (!formik.errors.idCurrency) {
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        idCurrency: e.target.value,
                      })
                      if (e.target.value !== 3) {
                        setShowExchange(true)
                      } else {
                        setShowExchange(false)
                      }
                    }
                  }}
                  variant="outlined"
                  error={formik.errors.idCurrency}
                >
                  <MenuItem value={''}>Seleccione una opción</MenuItem>
                  {currencies &&
                    currencies.map((item, key) => (
                      <MenuItem key={key} value={item.IdCurrency}>
                        {item.Description}
                      </MenuItem>
                    ))}
                </Select>
                {formik.errors.idCurrency ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.idCurrency}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          {showRequiredAmount && (
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  10. Monto requerido <span style={{ color: 'red' }}>*</span>
                  <a
                    data-tip="
                        - Microempresa (Hasta 5 empleados): Hasta $100,000.00<br/>
                        - Pequeña Empresa (De 6 a 50 empleados): Hasta $400,000.00<br/>
                        - Mediana Empresa (De 51 a 100 empleados): Hasta $1,000,000.00
                      "
                    data-for="infoAmountPop"
                    style={{ cursor: 'pointer', textAlign: 'justify' }}
                  >
                    <ErrorOutlineIcon fontSize="small" />
                    <ReactTooltip
                      id="infoAmountPop"
                      effect="solid"
                      multiline={true}
                      type="dark"
                      className="ayudaResponsive"
                    />
                  </a>
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <NumberFormat
                    id="requiredAmountSourceCurrency"
                    name="requiredAmountSourceCurrency"
                    customInput={TextField}
                    thousandSeparator={true}
                    value={amountTest}
                    allowLeadingZeros={false}
                    onChange={(e) => {
                      let inputValue = e.target.value.replaceAll(',', '')

                      // Remove non-numeric characters
                      // Limit the input length to 18 characters

                      if (inputValue.length > 12) {
                        inputValue = inputValue.slice(0, 12)
                      }

                      inputValue = Number(inputValue)

                      setAmountTest(inputValue)
                      if (formik.values.idCurrency === 3) {
                        formik.setFieldValue(
                          'requiredAmountDollarsCurrency',
                          inputValue,
                        )
                        formik.setFieldValue(
                          'requiredAmountSourceCurrency',
                          inputValue,
                        )
                        setPreEligibilityForm({
                          ...preEligibilityForm,
                          requiredAmountSourceCurrency: inputValue,
                          requiredAmountDollarsCurrency: inputValue,
                        })
                      } else if (
                        formik.values.idCurrency !== 3 &&
                        formik.values.idCurrency !== ''
                      ) {
                        formik.setFieldValue(
                          'requiredAmountSourceCurrency',
                          inputValue,
                        )
                        setPreEligibilityForm({
                          ...preEligibilityForm,
                          requiredAmountSourceCurrency: inputValue,
                        })
                      }
                    }}
                    autoComplete="off"
                    allowNegative={false}
                    error={formik.errors.requiredAmountSourceCurrency}
                    variant="outlined"
                    onBlur={() => getExchange()}
                    isNumericString={true}
                    inputProps={{ maxLength: 18 }}
                    fixedDecimalScale
                    decimalScale={2}
                  />
                  {formik.errors.requiredAmountSourceCurrency ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.requiredAmountSourceCurrency}
                    </div>
                  ) : null}
                  {formik.errors.requiredAmountDollarsCurrency ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.requiredAmountDollarsCurrency}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
            </Grid>
          )}
          {showExchange ? (
            <Grid item xs={12} sm={12} md={12} style={{ marginTop: '8px' }}>
              <label style={{ color: '#8080809e', fontWeight: '400' }}>
                Equivalente en dólares:{' '}
                {loadingExchange ? (
                  <CircularProgress color="inherit" size={17} />
                ) : (
                  <strong>
                    <NumberFormat
                      value={amountExchange}
                      thousandSeparator={true}
                      decimalScale={2}
                      displayType={'text'}
                      isNumericString={true}
                      fixedDecimalScale
                    />
                  </strong>
                )}
              </label>
            </Grid>
          ) : null}

          <Grid container spacing={1} className="general_button">
            <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'right' }}>
              <Button
                /* onClick={()=> next()} */
                type="submit"
                className="button__wizard button__next"
                disabled={loadingExchange || exchangeError}
              >
                Siguiente
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  )
}

export default GeneralData
